import { render, staticRenderFns } from "./index.vue?vue&type=template&id=73a5fa07&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a5fa07')) {
      api.createRecord('73a5fa07', component.options)
    } else {
      api.reload('73a5fa07', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=73a5fa07&", function () {
      api.rerender('73a5fa07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/index.vue"
export default component.exports